import gql from 'graphql-tag';

const GET_EXTERNAL_ISSUES = gql`
    query getExternalIssues {
        getExternalIssues {
            internalCode
            payload {
                id
                name
                isActive
                comment
                createdAt
            }
        }
    }
`;

export default GET_EXTERNAL_ISSUES;
